import { Helmet } from "react-helmet-async";

export const SITE_URL = "https://www.lawnworksnwa.com";
export const SITE_NAME = "Lawnworks Of NWA";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;

interface SeoProps {
  title: string;
  description: string;
  path?: string;
  keywords?: string;
  noindex?: boolean;
}

const normalizePath = (path = "/") => {
  if (path === "/") return "/";
  return path.startsWith("/") ? path : `/${path}`;
};

export const absoluteUrl = (path = "/") => `${SITE_URL}${normalizePath(path)}`;

const titleCase = (segment: string) =>
  segment
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

export const Seo = ({ title, description, path = "/", keywords, noindex = false }: SeoProps) => {
  const url = absoluteUrl(path);
  const segment = normalizePath(path).replace(/^\//, "");
  const breadcrumb = segment
    ? {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
          { "@type": "ListItem", position: 2, name: titleCase(segment), item: url },
        ],
      }
    : null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow"} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {breadcrumb && (
        <script type="application/ld+json">{JSON.stringify(breadcrumb)}</script>
      )}
    </Helmet>
  );
};
